import React from 'react';
import { Link } from 'react-router-dom';
import { Scales, WhatsappLogo, EnvelopeSimple, InstagramLogo, MapPin } from '@phosphor-icons/react';

export const Footer = () => {
  return (
    <footer className="bg-[#2A2A2A] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_bpc-loas/artifacts/ww7z8lbd_Timbre%20RDC%20-%20enquadramento%20.jpg" 
                alt="RDC Advogados"
                className="h-10 w-auto object-contain brightness-200"
              />
              <div>
                <div className="text-xl font-bold playfair tracking-tight">RDC Advogados</div>
                <div className="text-sm text-white/70 ibm-plex">Rio de Janeiro</div>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              Atuação jurídica sóbria, estratégica e comprometida com orientação segura em demandas trabalhistas, de saúde, previdenciárias e defesa em busca e apreensão. Mais de 15 anos de experiência.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold playfair mb-4">Navegação</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-sobre">
                  Sobre o Escritório
                </Link>
              </li>
              <li>
                <Link to="/areas" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-areas">
                  Áreas de Atuação
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-contato">
                  Contato
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-blog">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Practice Areas */}
          <div>
            <h3 className="text-lg font-semibold playfair mb-4">Áreas de Atuação</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/trabalhista" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-trabalhista">
                  Direito Trabalhista
                </Link>
              </li>
              <li>
                <Link to="/plano-saude" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-plano-saude">
                  Ação contra Plano de Saúde
                </Link>
              </li>
              <li>
                <Link to="/bpc-loas" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-bpc-loas">
                  BPC/LOAS
                </Link>
              </li>
              <li>
                <Link to="/busca-apreensao" className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-busca-apreensao">
                  Defesa em Busca e Apreensão
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold playfair mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={20} weight="duotone" className="text-white/70 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-white/70">
                  Rua São José, nº 46, Grupo 506/507<br />
                  Centro - Rio de Janeiro/RJ<br />
                  CEP: 20.010-020
                </span>
              </li>
              <li>
                <a
                  href="https://wa.me/552128880258"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-sm text-white/70 hover:text-white transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <WhatsappLogo size={20} weight="duotone" />
                  <span>+55 21 2888-0258</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato.rdcadvogados@gmail.com"
                  className="flex items-center space-x-3 text-sm text-white/70 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <EnvelopeSimple size={20} weight="duotone" />
                  <span>contato.rdcadvogados@gmail.com</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/advogadosrdc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-sm text-white/70 hover:text-white transition-colors"
                  data-testid="footer-instagram"
                >
                  <InstagramLogo size={20} weight="duotone" />
                  <span>@advogadosrdc</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} RDC Advogados. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};